import http from "@/http-common";

class NotificationService {
  
  getNotificationList() {
    return http.get("/notification");
  }
  getLastNotificationList() {
    return http.get("/notification/last");
  }
  getNotificationListBySensor(desc_sensor) {
    return http.get(`/notification/sensor/${desc_sensor}`);
  }

  discardNotification(id) {
    return http.post(`/notification/discard/${id}`);
  }

  updateNotificationSettings(data) {
    return http.post(`/notification/settings/update`, data);
  }  

  getNotificationSettings() {
    return http.get(`/notification/settings`);
  }   
}

export default new NotificationService();
